import { NgModule } from '@angular/core';

import { FilterPipe } from '@core/pipes/filter.pipe';

import { InitialsPipe } from '@core/pipes/initials.pipe';

import { SafePipe } from '@core/pipes/safe.pipe';
import { StripHtmlPipe } from '@core/pipes/stripHtml.pipe';
import { CurrencyFcfaPipe } from './currency-fcfa.pipe';

@NgModule({
  declarations: [InitialsPipe, FilterPipe, CurrencyFcfaPipe, StripHtmlPipe, SafePipe, CurrencyFcfaPipe],
  imports: [],
  exports: [InitialsPipe, FilterPipe, CurrencyFcfaPipe, StripHtmlPipe, SafePipe]
})
export class CorePipesModule {}
